import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { Questionario } from "../models/questionario";
import { Pergunta } from "../models/pergunta";
import { Resposta } from "../models/resposta";
import { CategoriaPergunta } from "../models/categoria-pergunta";
import { Opcao } from "../models/opcao";
import { TipoOpcaoEnum } from "../util/tipo-opcao.enum";
import { RespostaItem } from "../models/resposta-item";
import { Observable } from "rxjs";
import { throwError } from 'rxjs';
import { ServiceUtil } from "../util/service.util";
import { HttpService } from "ems-oauth2-client";
import { QuestionarioRespostaVO } from "../models/questionario-resposta.vo";
import { map, catchError, publishReplay, refCount, flatMap } from 'rxjs/operators';

@Injectable()
export class QuestionarioDinamicoService extends ServiceUtil {
  private url = "";
  filtro: Questionario = new Questionario();

  constructor(private http: HttpService) {
    super();
  }

  // recupera Questionario Completo
  recuperaQuestionarioCompleto(
    idQuestionario: number,
    nomeQuestionario: string
  ): Observable<Questionario> {
    let novaUrl = "/questionario/questionario/completo";
    if (idQuestionario && idQuestionario != 0) {
      novaUrl += "/?id=" + idQuestionario;
    } else if (nomeQuestionario && nomeQuestionario != "") {
      novaUrl += "/?nome=" + nomeQuestionario;
    } else {
      throwError("Id ou nomeQuestionario deve estar preenchido");
    }

    return this.http
      .get(novaUrl)
      .pipe(map(this.extractObjectDataQuestionario),
       catchError(this.handleError),
       publishReplay(1),
       refCount());
  }

  // recupera somente os campos filtros do questionário
  recuperaFiltroQuestionarioCompleto(
    idQuestionario: number
  ): Observable<Questionario> {
    this.url = "/questionario/questionario";
    return this.http
      .get(this.url + "/completo_filtro/" + idQuestionario)
      .pipe(map(this.extractListDataQuestionario),
       catchError(this.handleError),
       publishReplay(1),
       refCount());
  }

  // recupera questionario completo, porem soh os campos que filtro = true forem marcados
  recuperaFiltroQuestionarioCompletoPorNomeUnico(
    nomeUnico: string
  ): Observable<any> {
    this.url = "/questionario/questionario";
    let novaUrl = this.url + "/?filter={";
    novaUrl += 'nomeUnico:"' + nomeUnico + '"';
    novaUrl += "}";

    return this.http
      .get(novaUrl)
      .pipe(map(response => <Questionario[]>response),
       flatMap((response: Questionario[]) => {
        return this.recuperaFiltroQuestionarioCompleto(
          response[0].id
        ) as Observable<Questionario>;
      }),
       catchError(this.handleError),
       publishReplay(1),
       refCount());
  }

  /**
      Preenche a opcao e OpcaoValor selecionada no questionario dinamico
       A Regra eh:
      Se opcao.tipoOpcao == Entrada
          entao valorOpcao = codigoOpcaoSelecionada e opcao= codigoOpcaoSelecionada
       Se opcao.tipoOpcao == RespostaQuestionario
          entao valorOpcao =  codigoOpcaoSelecionada e opcao = idOpcao
      Retorna o respostaItem com opcao e opcaoValor preenchido
      **/
  preencherOpcao(pergunta: Pergunta, opcaoSelecionada: string): RespostaItem {
    this.url = "/questionario/resposta_item";
    let opcao: Opcao = new Opcao();
    let respostaItem: RespostaItem = new RespostaItem();
    // A regra eh a seguinte: sempre recuperar a primeira opcao.
    // pq ela jah diz tudo sobre minha a opcao, como o tipo dela.
    if (pergunta.opcoes != null && pergunta.opcoes.length > 0) {
      opcao = pergunta.opcoes[0];
    } //else{
    //return null;
    //}

    if (opcao.tipoOpcao == TipoOpcaoEnum.Entrada) {
      respostaItem.opcao = parseInt(opcaoSelecionada);
      respostaItem.opcaoValor = parseInt(opcaoSelecionada);
      return respostaItem;
    } else if (opcao.tipoOpcao == TipoOpcaoEnum.RespostaQuestionario) {
      respostaItem.opcao = opcao.id;
      respostaItem.opcaoValor = parseInt(opcaoSelecionada);
      return respostaItem;
    } else if (opcao.tipoOpcao == TipoOpcaoEnum.Servico) {
      respostaItem.opcao = opcao.id;
      respostaItem.opcaoValor = parseInt(opcaoSelecionada);
      return respostaItem;
    }
    return respostaItem;
  }

  /**
      Recupera as categorias de um Questionario
      **/
  recuperaCategoriasQuestionario(
    idQuestionario: number
  ): Observable<CategoriaPergunta[]> {
    let novaUrl = "/questionario/categoria_pergunta";
    novaUrl += "/?filter={";
    novaUrl += 'questionario:"' + idQuestionario + '"';
    novaUrl += "}";

    return this.http
      .get(novaUrl)
      .pipe(map(response => {
        var result = response;
        return response;
      }),
       catchError(this.handleError),
       publishReplay(1),
       refCount());
  }

  /**
      Recupera as categorias de um Questionario
      **/
  recuperaPerguntasCategoria(idCategoria: number): Observable<Pergunta[]> {
    let novaUrl = "/questionario/pergunta";
    novaUrl += "/?filter={";
    novaUrl += '"categoria":"' + idCategoria + '"';
    novaUrl += "}";
    novaUrl += "&sort=ordem";

    return this.http
      .get(novaUrl)
      .pipe(map(response => {
        var result = response;
        return response;
      }),
       catchError(this.handleError),
       publishReplay(1),
       refCount());
  }

  /**
        Recupera um objeto Pergunta pelo idPergunta
      **/
  public recuperaPerguntaFromIdPergunta(
    idPergunta: number
  ): Observable<Pergunta> {
    let novaUrl = "/questionario/pergunta/" + idPergunta;

    return this.http
      .get(novaUrl)
      .pipe(map(response => {
        var result = response;
        return response;
      }),
       catchError(this.handleError),
       publishReplay(1),
       refCount());
  }

  updateResposta(resposta: Resposta) {
    this.url = "/questionario/resposta";
    let body = JSON.stringify(resposta);
    if (!resposta.id) {
      return this.http
        .post(this.url, body)
        .pipe(map(response => <Resposta>response),
         catchError(this.handleError));
    } else {
      return this.http
        .put(this.url + "/" + resposta.id, body)
        .pipe(map(response => <Resposta>response),
         catchError(this.handleError),
         publishReplay(1),
         refCount());
    }
  }

  // recupera por id
  getId(id: number): Observable<Questionario> {
    this.url = "/questionario/questionario";
    return this.http
      .get(this.url + "/" + id)
      .pipe(map(response => response),
       catchError(this.handleError),
       publishReplay(1),
       refCount());
  }

  public comparar(idResposta: number, idResposta2: number): Observable<QuestionarioRespostaVO[]> {
    let url =  "/questionario/resposta/";
    return this.http
      .get(url + idResposta + "/comparar/" + idResposta2)
      .pipe(map(response => response),
       catchError(this.handleError),
       publishReplay(1),
       refCount());
  }

  // extrai objeto da resposta http
  private extractObjectDataQuestionario(res: any) {
    return res;
  }

  // extrai lista da resposta http
  private extractListDataQuestionario(res: any) {
    return res;
  }
}
